import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChipBase from "../BaseChipComponents/AppliedFilterChipBase";
import { useStore } from "utils/useStore";
import { ApplicationFiltersStore } from "stores/ApplicationFilters/ApplicationFiltersStore";
import React from "react";
import { EvaluationType } from "stores/ApplicationFilters/Filters/EvaluationType";

export const EvaluationTypesChips = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const globalApplicationFiltersStore = useStore(ApplicationFiltersStore);
    const applicationFiltersStore = props.store ?? globalApplicationFiltersStore;

    if (
        globalApplicationFiltersStore.authStore.canUserView(
            "Restrict Evaluations",
        ) &&
        !globalApplicationFiltersStore.authStore.isUserUltra()
    ) {
        return null;
    }

    return applicationFiltersStore.evaluationTypes.map((evaluationType) => (
        <AppliedFilterChipBase
            key={evaluationType}
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() =>
                applicationFiltersStore.toggleEvaluationType(evaluationType)
            }
        >
            {EvaluationType.toString(evaluationType)}
        </AppliedFilterChipBase>
    ));
});
